export default __webpack_public_path__ + "static/media/testNew.b616fbda.gif";